<div class="dialog-wrapper display-flex">

    <div class="success-message flex-centered-container display-flex-column">
        <mat-icon class="check-icon text-positive">
            check_circle_outline
        </mat-icon>

        <h2 class="margin-8-vr">
            You're all set!
        </h2>

        <p class="text-center font-bold">
            <span *ngIf="!isSaveOnly">Algo request sent for <span class="text-accent">{{ strategy.algoName }}</span></span>
            <span *ngIf="isSaveOnly"><span class="text-accent">{{ strategy.algoName }}</span> is successfully {{this.strategy.update ? 'updated': 'saved'}}</span>
        </p>

        <!-- Sending data to dialog after the dialog is closed to redirect to market watch only when needed -->

        <button mat-stroked-button
            class="underline cursor-pointer"
            color="accent"
            (click)="routeTo(RouteMap.books)">
                Track PnL
        </button>


        <div class="action full-width flex-centered-container bg-accent cursor-pointer"
            (click)="routeTo(RouteMap.dashboard)">
             Return to Dashboard
        </div>

    </div>

</div>
